module.exports = __webpack_public_path__ + "img/galeria-esp-marinas-4.81a59290.jpg";